import styled from "styled-components/macro";
import { imageFilter } from "../constants";
import { spacing, colorState, typography, device } from "../../Foundation";

export const ReactPaginateStyle = styled.div`
    display: flex;
    flex: 1;
    justify-content: end;

    .pagination {
        cursor: pointer;

        @media screen and (${device.md}) {
            flex-wrap: wrap;
            display: flex;
            justify-content: center;
        }

        li {
            font-size: ${typography.size.txs};
            font-weight: ${typography.weight.regular};
            border-radius: ${spacing.spacing_8};
            outline: none;
            color: ${colorState.text.primary};
            display: flex;
            margin: 5px;

            &:hover {
                border-color: ${(props): string => props.theme.colors.primary.main.backgroundColor};
                outline: none;
                color: ${(props): string => props.theme.colors.primary.main.backgroundColor};
            }

            a {
                outline: none;
                padding: 0 0.2rem;
                display: flex;
                justify-content: center;
                width: 35px;
                height: 35px;
                align-items: center;
            }
        }

        .disabled {
            a {
                cursor: not-allowed;
            }
        }

        .active {
            color: ${colorState.text["primary-inverse"]};
            background-color: ${colorState.surface.brand.primary};
            cursor: default;
            outline: none;

            &:hover {
                color: ${(props): string => props.theme.colors.neutral.dark.color};
            }

            a {
                outline: none;
            }
        }

        .labels {
            width: 7px;
            height: 10px;
            filter: invert(0.5);

            &:hover {
                filter: ${imageFilter};
            }
        }

        .flip {
            transform: rotate(180deg);
        }

        .breakLabel:hover {
            filter: ${imageFilter};
        }
    }
`;

export const SelectValue = styled.div`
    flex: 1;
    max-width: 20%;

    .flex-content {
        flex: 1;
    }
`;

export const TableFooterPaginationStyles = styled.div`
    display: flex;
    justify-content: space-between;
    background-color: ${colorState.surface.default.tertiary};
    border-radius: ${spacing.spacing_8};
    margin: ${spacing.spacing_12} ${spacing.spacing_12};
    padding: ${spacing.spacing_8} ${spacing.spacing_12};
    flex-wrap: wrap;

    @media screen and (${device.lg}) {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .select-pages {
        min-width: 80px;
        max-width: 100px;
    }

    .pagination-details {
        display: flex;
        align-items: center;
        width: 100%;
        gap: ${spacing.spacing_8};
        flex: 1;
        justify-content: start;

        @media screen and (${device.lg}) {
            justify-content: center;
        }

        .pagination-content {
            display: flex;
            gap: ${spacing.spacing_12};
            align-items: center;
            white-space: nowrap;
            font-size: ${typography.size.txs};
            font-weight: ${typography.weight.regular};
            line-height: ${spacing.spacing_16};
            color: ${colorState.text.secondary};

            @media screen and (${device.xxl}) {
                flex-wrap: wrap;
            }
        }
    }
`;
